/**
 * Timestamps are rendered in **Europe/Berlin**, not the viewer's local zone.
 *
 * Everyone using this app is in Germany, and the shops they coordinate with are
 * too. A browser reporting UTC (a server-side render, a VPN, a misconfigured
 * machine) would otherwise show times two hours off during CEST, which is
 * exactly wrong when the question is "when did this order come in" and the
 * answer decides whether a shop can still ship today.
 *
 * The zone is fixed rather than read from the browser for the same reason: the
 * operator and the shop must be reading the same clock.
 */
const BERLIN = "Europe/Berlin";

const DATE_TIME = new Intl.DateTimeFormat("de-DE", {
	timeZone: BERLIN,
	day: "2-digit",
	month: "2-digit",
	year: "numeric",
	hour: "2-digit",
	minute: "2-digit",
});

const TIME_ONLY = new Intl.DateTimeFormat("de-DE", {
	timeZone: BERLIN,
	hour: "2-digit",
	minute: "2-digit",
});

/** `26.08.2026, 13:02` - date and time, Berlin. */
export function formatBerlin(iso: string | null | undefined): string {
	if (!iso) return "-";
	const d = new Date(iso);
	// An unparseable timestamp must not render "Invalid Date" in a table.
	if (Number.isNaN(d.getTime())) return "-";
	return DATE_TIME.format(d);
}

/** `13:02` - time only, for when the date is already obvious from context. */
export function formatBerlinTime(iso: string | null | undefined): string {
	if (!iso) return "-";
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return "-";
	return TIME_ONLY.format(d);
}
